import { createSelector } from 'reselect'
import { SimpleIndex } from '../common/simpleSearch'
import { indexBy } from 'lodash/fp'
import { ILocation } from '../types/location'
import { ILocationsState } from './locationsReducer'

interface IRootState {
  locations: ILocationsState
}

export const locationsRootSelector = (state: IRootState) => state.locations

export const locationsSelector = createSelector(
  locationsRootSelector,
  (locationsRoot) => locationsRoot.locations,
)

export const currentLocationSelector = createSelector(
  locationsRootSelector,
  (locationsRoot) => locationsRoot.currentLocation,
)

export const locationsDictSelector = createSelector(
  locationsSelector,
  (locations) => indexBy('id', locations),
)

export const locationsSearchIndexSelector = createSelector(
  locationsSelector,
  (locations) =>
    new SimpleIndex<ILocation>(locations, {
      keys: ['code', 'description', (l) => l.user?.name ?? ''],
    }),
)

export const locationByIdSelector = (id: number) =>
  createSelector(locationsDictSelector, (locationsDict) => locationsDict[id])
